import ContragentCard from '@/shared/components/contragent-card'
import { useUpdateAdditionalOrdData } from '@/shared/api'
import { CheckIcon, ContentContainer } from '@/shared/ui'
import {
    ContragentResponse,
    VkOrdApiKeyResponse,
} from '@synapex/shared2/gateway-rest-api'
import { AccountWorkspaceDescriptor } from '@synapex/shared2/entities'

type AgencyProps = {
    ordData: VkOrdApiKeyResponse | undefined | null
} & AccountWorkspaceDescriptor

const Agency: React.FC<AgencyProps> = ({ ordData, ...аwsDescr }) => {
    const { mutateAsync: updateAdditionalOrdData } =
        useUpdateAdditionalOrdData()

    function handleSelectContragent(contragent: ContragentResponse | null) {
        void updateAdditionalOrdData({
            awd: аwsDescr,
            input: {
                adOrdAgencyId: contragent?.ord_contragent_id || null,
            },
        })
    }

    return (
        <ContentContainer>
            <div className="flex items-center gap-[10px] pb-3">
                <h2 className="text-lg font-extrabold">Реквизиты агентства</h2>
                <CheckIcon
                    className="h-4 w-4"
                    checked={!!ordData?.adOrdAgencyId}
                />
            </div>

            <div className="w-[302px]">
                <ContragentCard
                    {...аwsDescr}
                    onSelectContragent={handleSelectContragent}
                    allowEdit={!!ordData?.vkOrdApiKey}
                    currentContragentId={ordData?.adOrdAgencyId}
                    tooltipMessage="Если хотите изменить, добавте API ключ ОРД"
                    roleType="agency"
                />
            </div>
        </ContentContainer>
    )
}

export default Agency
